import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthResponseDto, AuthService } from '../../services';


@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    standalone: false
})
export class LoginFormComponent {
  loading = false;
  formData: any = {};

  constructor(private authService: AuthService, private router: Router) { }

  async onSubmit(e: Event) {
    e.preventDefault();
    const { email, password } = this.formData;
    this.loading = true;

    localStorage.setItem("notificationToken", ""); // setting token a vuoto di base 

    this.authService.logIn(email, password).subscribe({
      next: (res: AuthResponseDto) => {

        if (res.isAuthSuccessful) {
          localStorage.setItem("jwt", res.token);
          localStorage.setItem("tenantId", email.substring(0, 3));
          localStorage.setItem("user", email.trim().toUpperCase());

          localStorage.setItem("loginOptions", JSON.stringify(res));

          this.router.navigate([this.authService.lastAuthenticatedPath]);

           if (res.notificationToken) {
              localStorage.setItem("notificationToken", res.notificationToken);
            }
        }
        else {
          this.loading = false;
          notify(res.errorMessage, 'error', 2000);
        }

      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        notify(err.error.errorMessage, 'error', 2000);
      }
    });
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule
  ],
  declarations: [ LoginFormComponent ],
  exports: [ LoginFormComponent ]
})
export class LoginFormModule { }
